// extracted by mini-css-extract-plugin
module.exports = {"segments":"styles_segments__1mLMs"};